import React, { useState, useRef, useEffect, useCallback } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import {
    Alterar, Excluir, Visualizar, AlteracaoLote, AlteracaoStatus, HistoricoStatus, Btn, GuiaComplementar, Conferencia, AlterarSocioGuia,
    VisualizarErro, VisualizarArquivo, EnviarLoteCoop, VisualizarPagamento,
    BtnAcaoAlternativa, BtnAcao, LinkArquivos, RemoverLote, AlterarComPermissao
} from '../../../../components/Acoes'
import { BotaoPadrao } from '../../../../components/Botoes'
import { getUsuario, getApi } from '../../../../util/Configuracoes'
import { ACOES, GUIA_STATUS, MODULO, SERVICE } from '../../../../util/Enums'
import { get, excluir, salvar, validar, put, putComAcao } from '../../../../util/AcessoApi'
import { mostrarToast } from '../../../../components/Toasts'
import { ModalCadastro, ModalDuasOpcoes, ModalVisualizacao } from '../../../../components/Modais'
import { mensagens, useWindowSize } from '../../../../util/Utilitarios.js'
import { Formik, Form } from "formik";
import Yup from '../../../../util/Validacoes';
import { LoadRelatorio } from '../../../../components/Loading'
import { InputDatePicker, InputPadrao, InputTimePicker, TextArea } from '../../../../components/Inputs'
import { InputGuiaStatus, InputLoteGuia, InputLoteGuiaAcao } from '../../../../components/InputsAutoComplete'
import moment from 'moment';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import DetalhesHistorico, { HistoricoEnvio } from './DetalhesHistorico'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { toast } from 'react-toastify'
import { FaCheck, FaTimes } from 'react-icons/fa'
import InputArquivoS3, { InputArquivoS3Modal } from '../../../../components/InputArquivoS3V2'
import Accordion from '../../../../components/Accordion'
import { HeaderConsulta } from '../../../../components/Headers'
import ModalLegendaStatus from '../../../../components/ModalLegenda'

// import { VisualizacaoErro } from './Visualizacao'
const modulo = 76

const ConsultaGuia = rProps => {

    const [data, setData] = useState([])
    const [modalAlteracaoLote, setModalAlteracaoLote] = useState(false)
    const [modalAlteracaoStatus, setModalAlteracaoStatus] = useState(false)
    const [itemTrocarLote, setItemTrocarLote] = useState({})
    const [itemTrocarStatus, setItemTrocarStatus] = useState({})
    const target = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [showModalDetalhes, setShowModalDetalhes] = useState(false)
    const [showModalVisualizarErro, setShowModalVisualizarErro] = useState(false)
    const [itemDetalhes, setItemDetalhes] = useState([])
    const { width } = useWindowSize()
    const [itemVisualizarErro, setItemVisualizarErro] = useState({})
    const [itemTrocaTipoGuia, setItemTrocaTipoGuia] = useState({})
    const history = useHistory()
    const [showModalAposSalvar, setShowModalAposSalvar] = useState(false)
    const [avisoSalvar, setAvisoSalvar] = useState()
    const [modalInserirArquivos, setModalInserirArquivos] = useState(false)
    const [itemArquivos, setItemArquivos] = useState({})
    const [modalLegendaStatus, setModalLegendaStatus] = useState(false)
    const [disabledButton, setDisabledButton] = useState({ disabledRow: false, id: null })


    useEffect(() => {
        if (history.location.state) {
            setAvisoSalvar(history.location.state)
            setShowModalAposSalvar(true)
            history.push()
        }
    }, [history])

    useEffect(() => {
        if (modalAlteracaoLote === false) {
            setItemTrocarLote({});
        }
    }, [modalAlteracaoLote])

    const columns = React.useMemo(
        () => [{
            id: 'consulta-guia',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Código',
                    Placeholder: 'Para mais de um código utilize "," ',
                    accessor: 'id_guia',
                    visivel: false,
                    apenasDataGrid: true,
                    filtro: {
                        tipo: 'pesquisa-geral',
                        idColuna: 'guia_id',
                    }
                },
                {
                    Header: 'Cod. Barras',
                    accessor: 'codigo_barras',
                    html: item => <div className='min-width-125' ><span >{item.codigo_barras}</span></div>,
                    ordenamento: {
                        tipo: 'texto'
                    }
                }, {
                    Header: 'Paciente',
                    accessor: 'nome_beneficiario',
                    ordenamento: {
                        tipo: 'texto'
                    }
                }, {
                    Header: 'Data Proc.',
                    accessor: 'data_procedimento',
                    html: item => <div className='min-width-100' ><span >{item.data_hora_procedimento}</span></div>,
                    ordenamento: {
                        tipo: 'data'
                    }
                }, {
                    Header: 'Referência (LOTE)',
                    accessor: 'referencia',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'referencia_lote',
                        idColuna: 'referencia',
                        monthPicker: true,
                    }
                }, {
                    Header: 'Lote',
                    accessor: 'guia_lote_id',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'lote',
                        idColuna: 'guia_lote_id'
                    }
                },
                {
                    Header: 'Sócio Cooperativa',
                    accessor: 'executante_externo',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'socio_cooperativa',
                        idColuna: 'guia_profissional_cooperativa.socio_id'
                    }
                },
                {
                    Header: 'Sócio Equipe',
                    accessor: 'executante_interno',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'socio_equipe',
                        idColuna: 'guia_procedimento_profissional.socio_id'
                    }
                },
                {
                    Header: 'Cirurgião',
                    accessor: 'cirurgiao',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'cirurgiao',
                        idColuna: 'guia.cirurgiao_id',
                    }
                },
                {
                    Header: 'Empresa',
                    accessor: 'empresa',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'empresa',
                        idColuna: 'guia.empresa_id',
                    }
                },
                {
                    Header: 'Op. de Saúde',
                    accessor: 'operadora_saude',
                    html: item => <div className='min-width-125' ><span >{item.operadora_saude}</span></div>,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'operadora_saude',
                        idColuna: 'guia.operadora_saude_id'
                    }
                }, {
                    Header: 'Estab. de Saúde',
                    accessor: 'estabelecimento_saude',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'estabelecimento_saude',
                        idColuna: 'guia.estabelecimento_saude_id'
                    }
                },
                {
                    Header: 'Contrato',
                    accessor: 'contrato',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'contrato_filtro',
                        idColuna: 'guia.contrato_id',

                    }
                },
                {
                    Header: 'Status',
                    accessor: 'status',
                    html: item => <OverlayTrigger
                        popperConfig={{
                            modifiers: {
                                preventOverflow: {
                                    enabled: false
                                }
                            }
                        }}
                        id={Math.random()}
                        placement="bottom"
                        delay={{ show: 25, hide: 25 }}
                        overlay={(props) => <Tooltip id={'tooltip ' + props.id ? props.id : 'tooltip ' + Math.random()} {...props}>{item.status}</Tooltip>}>
                        <div className='guia-status-ellipsis' style={{ background: item.cor_status }}>{item.status}</div>
                    </OverlayTrigger>,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'guia_status_convenio',
                        idColuna: 'guia_status.id'
                    }
                },
                {
                    Header: 'Valor',
                    accessor: 'valor_total_formatado',
                    html: item => <div className='min-width-100' ><span >{item.valor_total_formatado}</span></div>,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Data Procedimento inicial',
                    accessor: 'data_inicial_procedimento',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_inicial_procedimento',
                        idColuna: 'data_procedimento_inicial',
                        datePicker: true,
                        date: true

                    }
                }, {
                    Header: 'Data Procedimento Final',
                    accessor: 'data_final_procedimento',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_final_procedimento',
                        idColuna: 'data_procedimento_final',
                        datePicker: true,
                        date: true
                    }
                },
                {
                    Header: 'Hora Procedimento Inicial',
                    accessor: 'hora_inicial_procedimento',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'hora_inicial_procedimento',
                        idColuna: 'hora_procedimento_inicial',
                        timePicker: true
                    }
                }, {
                    Header: 'Hora Procedimento Final',
                    accessor: 'hora_final_procedimento',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'hora_final_procedimento',
                        idColuna: 'hora_procedimento_final',
                        timePicker: true
                    }
                },
                // {
                //     Header: 'Tipo Exec.',
                //     accessor: 'tipo_executante',
                //     visivel: false,
                //     // html: item => <div className='min-width-125' ><span >{item.tipo_executante}</span></div>,
                //     alinhamento: 'text-center',
                //     ordenamento: {
                //         tipo: 'texto'
                //     },
                //     filtro: {
                //         tipo: 'tipo_executante',
                //         idColuna: 'guia_tipo_executante.id'
                //     }
                // },
                {
                    Header: 'Tipo Guia',
                    accessor: 'guia_tiss',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Lote',
                    accessor: 'numero_lote',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    html: item => <OverlayTrigger
                        popperConfig={{
                            modifiers: {
                                preventOverflow: {
                                    enabled: false
                                }
                            }
                        }}
                        id={Math.random()}
                        placement="bottom"
                        delay={{ show: 25, hide: 25 }}
                        overlay={(props) => <Tooltip id={'tooltip ' + props.id ? props.id : 'tooltip ' + Math.random()} {...props}>{item.descricao_lote}</Tooltip>}>
                        <div className='guia-status-ellipsis' style={{ background: item.cor_lote }}>{item.numero_lote}</div>
                    </OverlayTrigger>,
                },
                {
                    Header: 'Data Registro',
                    accessor: 'data_insercao',
                    html: item => <div className='min-width-125' ><span >{item.data_insercao}</span></div>,
                    ordenamento: {
                        tipo: 'data'
                    }
                },
                {
                    Header: 'Data Registro Inicial',
                    accessor: 'data_inicial',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_inicial',
                        idColuna: 'data_registro_inicial',
                        name: `data_registro_inicial`,
                        datePicker: true,
                        date: true
                    }
                }, {
                    Header: 'Data Registro Final',
                    accessor: 'data_final',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_final',
                        idColuna: 'data_registro_final',
                        name: `data_registro_final`,
                        datePicker: true,
                        date: true

                    }
                }, {
                    Header: 'Hora Registro Inicial',
                    accessor: 'hora_inicial_registro',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'hora_inicial_registro',
                        idColuna: 'hora_registro_inicial',
                        timePicker: true
                    }
                }, {
                    Header: 'Hora Registro Final',
                    accessor: 'hora_final_registro',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'hora_final_registro',
                        idColuna: 'hora_registro_final',
                        timePicker: true
                    }
                },
                {
                    Header: 'Status Envio',
                    accessor: 'status_envio',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'status_envio',
                        idColuna: ' guia.status_envio_id',
                    }
                },
                {
                    Header: 'Usuario Inserção',
                    accessor: 'usuario_insercao',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'usuario_top',
                        idColuna: ' guia.usuario_id_insercao',
                    }
                },

                {
                    Header: 'Usuario Alteração',
                    accessor: 'usuario_id_alteracao',
                    visivel: false,

                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'usuario_alteracao_top',
                        idColuna: ' guia.usuario_id_alteracao',
                    }
                },
                {
                    Header: 'Data Alteração Inicial',
                    accessor: 'data_ultima_alteracao_inical',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_inicial',
                        idColuna: 'data_alteracao_inicial',
                        name: `data_alteracao_inicial`,
                        datePicker: true,
                        date: true
                    }
                }, {
                    Header: 'Data Alteração Final',
                    accessor: 'data_ultima_alteracao_final',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_final',
                        idColuna: 'data_alteracao_final',
                        name: `data_alteracao_final`,
                        datePicker: true,
                        date: true

                    }
                }

            ]
        }], []
    )

    const exclusao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: rProps.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/faturamento/guia', propsAcao.row.id,
                    () => {
                        // getApi(setData, '/faturamento/guia')
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    }, propsAcao.row.descricao_auditoria)
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }


    const removerLoteGuia = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: rProps.modulo,
            acao_id: ACOES.REMOVER_LOTE
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length) {
                let status_guia = parseInt(propsAcao.row.id_status)
                if (status_guia === 1 || status_guia === 3 || status_guia === 4) {

                    putComAcao(ACOES.REMOVER_LOTE, rProps.modulo, propsAcao.row, '/faturamento/removerLoteGuia', () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    }, (e) => {
                        console.log('e: ', e);
                        mostrarToast('erro', mensagens.erro)
                    })
                } else {
                    mostrarToast('erro', 'Operação Bloqueada! O Status da Guia não permite essa ação.')
                }

            } else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }


    const objPermissao = {
        usuario_id: getUsuario().id,
        modulo_id: rProps.modulo,
        acao_id: ACOES.GUIA_COMPLEMENTAR
    }
    const objPermissaoArquivos = {
        usuario_id: getUsuario().id,
        modulo_id: 76,
        acao_id: ACOES.INSERIR_ARQUIVOS_GUIA
    }

    const OutrasAcoes = ({ propsAcao, ...props }) => {
        return (
            <Dropdown >
                <DropdownTrigger>
                    <Btn icone='icon-ellipsi' texto="Mais Ações" />
                </DropdownTrigger>
                <DropdownContent>
                    <div className="card-acoes-dropdown">
                        <div className="ajusta-dropdown-consulta-guia">
                            {[
                                <Excluir to={'/faturamento/guia/consulta/'} action={() => exclusao(propsAcao)} />,

                                <AlteracaoStatus action={() => {
                                    setItemTrocarStatus(propsAcao.row);
                                    setModalAlteracaoStatus(true)
                                }} />,
                                <HistoricoStatus action={() => {
                                    obterDetalhes(propsAcao.row);
                                    setShowModalDetalhes(true);

                                }} />,
                                <AlteracaoLote action={() => {
                                    setItemTrocarLote(propsAcao.row);
                                    setModalAlteracaoLote(true)
                                }} />,
                                <GuiaComplementar action={async () => {
                                    await Promise.resolve(get('/controleAcesso/permissao', objPermissao).then(function (val) {

                                        if (val.length) {
                                            history.push({ pathname: '/faturamento/guia-particular/cadastro', state: { idComplementar: propsAcao.row.id } })

                                        }
                                        else {
                                            mostrarToast('erro', 'O usuário não possui permissão para esta ação! Contate um administrador.')
                                        }

                                    }).catch((e) => mostrarToast('erro', mensagens['erro'])))

                                }} />,
                                propsAcao.row.envia_xml && propsAcao.row.numero_lote ? <EnviarLoteCoop id={propsAcao.row.id} texto="Enviar Guia para COOPANESTGO" disabled={disabledButton} action={() => {
                                    setDisabledButton({ disabledRow: true, id: propsAcao.row.id })
                                    var key = JSON.stringify({ "ID_GUIA": propsAcao.row.id + "", "ID_USUARIO": getUsuario().id + "" })
                                    rProps.obterWebService(JSON.stringify({
                                        "integrationType": "guia",
                                        "key": key,
                                        "usuarioId": getUsuario().id, "moduloId": 76, "acaoId": 32
                                    }), null, (async _ => setDisabledButton({ disabledRow: false, id: propsAcao.row.id })))
                                }} /> : undefined,
                                <Link to={{ pathname: '/faturamento/guia/visualizacaoXmlGerado/' + propsAcao.row.id }} target={'_blank'}><VisualizarArquivo action={() => { }} /></Link>,
                                <Link to={{ pathname: '/faturamento/guia/visualizacaoRetornoEnvio/' + propsAcao.row.id }} target={'_blank'}><VisualizarErro action={() => { }} /></Link>,
                                <BtnAcao icone="icon-Repeat-5" texto="Atualizar Status Coopanest" action={() => {
                                    atualizarStatus(propsAcao.row.id)
                                }} />,
                                <LinkArquivos action={async () => {
                                    await Promise.resolve(get('/controleAcesso/permissao', objPermissaoArquivos).then(function (val) {
                                        if (val.length > 0) {

                                            setItemArquivos(propsAcao.row)
                                            setModalInserirArquivos(true)
                                        }
                                        else {
                                            mostrarToast('erro', 'O usuário não possui permissão para esta ação! Contate um administrador.')
                                        }
                                    }).catch((e) => mostrarToast('erro', mensagens['erro'])))
                                }} />,
                                <Conferencia action={async () => {
                                    history.push({ pathname: '/faturamento/conferencia/cadastro', state: { id: propsAcao.row.id } })
                                }} />,
                                <AlterarSocioGuia action={async () => {
                                    // history.push({ pathname: '/faturamento/conferencia/cadastro', state: { id: propsAcao.row.id } })
                                    get('/controleAcesso/permissao', { usuario_id: getUsuario().id, modulo_id: 76, acao_id: ACOES.ALTERAR_SOCIO_GUIA }).then(function (val) {
                                        if (val.length)
                                            history.push({ pathname: '/faturamento/guia-socios/alterar', state: { id: propsAcao.row.id, alteracao_socio_guia: true, alteracao: true, particular: false, rotaConsulta: '/faturamento/guia/consulta' } })

                                        else
                                            mostrarToast('erro', mensagens['permissao'])
                                    }).catch((e) => mostrarToast('erro', mensagens['erro']))

                                }} />,

                                propsAcao.row.guia_lote_id !== null && (propsAcao.row.guia_status_id === 1 || propsAcao.row.guia_status_id === 3 || propsAcao.row.guia_status_id === 4) ?
                                    <RemoverLote action={() => {
                                        removerLoteGuia(propsAcao)

                                    }} /> : <></>,

                                propsAcao.row.guia_status_id === 13 ?
                                    <VisualizarPagamento action={() => {
                                        get('/controleAcesso/permissao', { usuario_id: getUsuario().id, modulo_id: 76, acao_id: ACOES.VISUALIZAR_PAGAMENTO }).then(function (val) {

                                            const url = '/faturamento/guia/visualizacaopagamento/' + propsAcao.row.id;

                                            if (val.length)
                                                window.open(url, '_blank');
                                            else
                                                mostrarToast('erro', mensagens['permissao'])
                                        }).catch((e) => mostrarToast('erro', mensagens['erro']))

                                    }} />
                                    : <></>,
                            ]}
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }

    const acoesObj = [ // AÇÕES PARA TELA 1920
        (propsAcao) => <Visualizar to={'/faturamento/guia/visualizacao/' + propsAcao.row.id} />,
        (propsAcao) => <AlterarComPermissao to={'/faturamento/guia/alteracao/' + propsAcao.row.id} modulo={modulo} acao={propsAcao.row.acao_id} target={'_self'} />,
        (propsAcao) => <OutrasAcoes propsAcao={propsAcao} />

    ]

    const acoesObj2 = [ // AÇÕES PARA TELA MENOR 1920
        (propsAcao) => <Visualizar to={'/faturamento/guia/visualizacao/' + propsAcao.row.id} />,
        (propsAcao) => <AlterarComPermissao to={'/faturamento/guia/alteracao/' + propsAcao.row.id} modulo={modulo} acao={propsAcao.row.acao_id} target={'_self'} />,
        (propsAcao) => <Excluir to={'/faturamento/guia/consulta/'} action={() => exclusao(propsAcao)} />,
        (propsAcao) => <AlteracaoStatus action={() => {
            setItemTrocarStatus(propsAcao.row);
            setModalAlteracaoStatus(true)
        }} />,
        (propsAcao) => <HistoricoStatus action={() => {
            obterDetalhes(propsAcao.row);
            setShowModalDetalhes(true);

        }} />,
        (propsAcao) => <AlteracaoLote action={() => {
            setItemTrocarLote(propsAcao.row);
            setModalAlteracaoLote(true)
        }} />,
        (propsAcao) => <Link to={{ pathname: '/faturamento/guia-particular/cadastro', state: { idComplementar: propsAcao.row.id } }}><GuiaComplementar /></Link>,
        (propsAcao) => propsAcao.row.envia_xml ? <EnviarLoteCoop disabled={disabledButton} action={() => {
            setDisabledButton(true)

            rProps.obterWebService(JSON.stringify({
                "integrationType": "guia",
                "key": JSON.stringify({ "ID_GUIA": propsAcao.row.id, "ID_USUARIO": getUsuario().id }),
                "usuarioId": getUsuario().id, "moduloId": 76, "acaoId": 32
            }), null, setDisabledButton(false))
        }} /> : undefined,
        (propsAcao) => <Link to={{ pathname: '/faturamento/guia/visualizacaoXmlGerado/' + propsAcao.row.id }}><VisualizarArquivo action={() => { }} /></Link>,
        (propsAcao) => <Link to={{ pathname: '/faturamento/guia/visualizacaoRetornoEnvio/' + propsAcao.row.id }}><VisualizarErro action={() => { }} /></Link>,
        (propsAcao) => <BtnAcao icone="icon-Repeat-5" texto="Atualizar Status Coopanest" to={''} action={() => {
            atualizarStatus(propsAcao.row.id)
        }} />,
        (propsAcao) => <BtnAcao icone="icon-Repeat-5" texto="Inserir Arquivos" to={''} action={() => {
            setItemTrocarLote(propsAcao.row);
            setModalInserirArquivos(true)

        }} />,


        (propsAcao) => propsAcao.row.guia_lote_id !== null && (propsAcao.row.guia_status_id === 1 || propsAcao.row.guia_status_id === 3 || propsAcao.row.guia_status_id === 4) ?
            <RemoverLote action={() => {
                removerLoteGuia(propsAcao)
            }} /> : <></>
    ]

    const atualizarStatus = (id) => {
        const toastify = toast('Aguarde...', { isLoading: false })
        toast.update(toastify, { render: 'Aguarde...', toastId: 'plasma_id' + id, isLoading: true });
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: rProps.modulo,
            acao_id: ACOES.ATUALIZAR_STATUS_COOPANEST
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length) {

                Promise.resolve(put(`/faturamento/atualizarStatusCoopanest/${id}`, {
                    auditoria: {
                        usuario: getUsuario().id,
                        modulo: rProps.modulo,
                        controle: id,
                        acao: ACOES.ATUALIZAR_STATUS_COOPANEST
                    }
                }, true, true))
                    .then(data => {

                        toast.update('plasma_id' + id, { autoClose: 5000, isLoading: false, type: 'success', render: <><FaCheck /> Status da Guia <b>{id}</b> foi atualizado com sucesso!</> });
                        target.current.atualizar();
                    })
                    .catch(erro => {
                        console.log('Erro ', erro)
                        toast.update('plasma_id' + id, { autoClose: 5000, isLoading: false, type: 'error', render: <><FaTimes /> {erro.response.data.erros}</> });
                    })
            }
            else
                toast.update('plasma_id' + id, { autoClose: 5000, isLoading: false, type: 'error', render: <><FaTimes /> {mensagens['permissao']}</> });
        }).catch((e) => toast.update('plasma_id' + id, { autoClose: 5000, isLoading: false, type: 'error', render: <><FaTimes /> {mensagens['permissao']}</> }))
    }

    const obterDetalhes = async (props) => {
        let { id } = props
        setItemDetalhes({ guia: [{ titulo: 'Carregando...' }] })
        let dados = {}
        dados.guia = [
            { titulo: 'Código', descricao: id },
            { titulo: 'Código Barras', descricao: props.codigo_barras },
            { titulo: 'Empresa', descricao: props.empresa },
            { titulo: 'Paciente', descricao: props.nome_beneficiario },
            { titulo: 'Data Procedimento', descricao: props.data_procedimento },
            { titulo: 'Acomodação', descricao: props.acomodacao },
        ]

        dados.socio_equipe = props.socio_equipe

        await Promise.resolve(get(`/faturamento/obterhistoricoguiastatus/${id}`)).then(val2 => {

            dados.historico_status = val2;
        })

        await Promise.resolve(get(`/faturamento/obterhistoricoguialote/${id}`)).then(val2 => {

            dados.historico_lote = val2;
        })

        await Promise.resolve(get(`/faturamento/obterMapaHorasGuia/${id}`)).then(val2 => {

            dados.mapa_horas = val2;
        })

        await Promise.resolve(get(`/faturamento/historicoSocioCoop/${id}`)).then(val => {
            dados.historico_socio_coop = val;
        })

        await Promise.resolve(get(`/faturamento/historicoSocioEquipe/${id}`)).then(val => {
            dados.historico_socio_equipe = val;
        })

        setItemDetalhes(dados)
    }



    return (
        <div>
            <DataGridAlternativa target={target} acoesObj={width <= 1822 ? acoesObj2 : acoesObj} data={data} columns={columns} caminhoBase='/faturamento/guia' setData={setData} acoes={true} modulo={rProps.modulo} colunaStatus={'status'} idStatus={'id_status'} corStatus={'cor_status'} ImpressaoOff={true}
                filtroAtivo={true} nomeSession={'ultimos_filtros_guia'} helpComponent={{ icone: 'icon-Note', action: _ => setModalLegendaStatus(true) }} updateStatus={{
                    action: _ => {
                        rProps.chamarWebService(JSON.stringify({ "integrationType": "", "key": "", "usuarioId": getUsuario().id, "moduloId": 76, "acaoId": 55 }), SERVICE.BATCH_UPDATE_STATUS, { titulo: 'Atualizando Status', mensagem: 'Atualizando os status de todas as Guias. O processamento ocorrerá em segundo plano', tempo: 10000 })
                    }
                }}
                titulo={'Consulta Guia'} tituloLista={'Lista Guia'}
                urlCadastro='/faturamento/guia/cadastro' icone={'icon-Professor'} caminhoConsultaFiltros='/faturamento/guiapaginacao'
                manutencaoLote='/faturamento/manutencao-lote/cadastro'
                manutencaoStatus='/faturamento/manutencao-status/cadastro'
                conferencia='/faturamento/conferencia/cadastro' />
            <DetalhesHistorico titulo={'Detalhes'} data={itemDetalhes} showModal={showModalDetalhes} setShowModal={setShowModalDetalhes} />
            <TrocarLote target={target} titulo={'Inserir/Alterar de Lote Guia'} abrirModal={modalAlteracaoLote} setAbrirModal={setModalAlteracaoLote} item={itemTrocarLote} />
            <ModalArquivos target={target} titulo={'Inserir/Alterar Arquivos Guia'} abrirModal={modalInserirArquivos} setAbrirModal={setModalInserirArquivos} item={itemArquivos} setItem={setItemArquivos} />
            <TrocarStatus target={target} titulo={'Alteração de Status Guia'} abrirModal={modalAlteracaoStatus} setAbrirModal={setModalAlteracaoStatus} item={itemTrocarStatus} />
            <ModalLegendaStatus target={target} titulo={'Legenda Status'} abrirModal={modalLegendaStatus} setAbrirModal={setModalLegendaStatus} item={itemTrocarStatus} particular={false} />
            <ModalDuasOpcoes showModal={showModalAposSalvar} setShowModal={setShowModalAposSalvar}
                funcaoOpcao1={() => { setShowModalAposSalvar(false); }}
                esconderFechar mensagem={<>
                    Guia:
                    <br />
                    <br />
                    <b>{avisoSalvar?.guia} </b> - {avisoSalvar?.paciente}
                    <br />

                </>}
                textoOpcao1={'OK'} esconderOpcao2
                classeOpcao1={'btn-sm btn-primary-modal primary'} />
        </div>
    )
}

const TrocarLote = ({ target, ...props }) => {
    const [salvando, setSalvando] = useState(false)
    const [carregando, setCarregando] = useState(false)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')

    const [validacao] = useState(Yup.object({
        lote: Yup.object().nullable().required(),
        justificativa: Yup.string()
    }))

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        let valuesAjustados = { ...values }
        valuesAjustados.status = values.status ? values.status.id : ''

        salvar(
            { id: props.item.id, ...values },
            '/faturamento/guiaalterarlote',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                props.setAbrirModal(false)
                setSalvando(false)
                target.current.atualizar()
            },
            (err) => {
                setSalvando(false)
            })
    }

    const validarSubmit = async (values, propsFormik) => {
        setSalvando(true)

        await validar(`/faturamento/validarLote`, { id: props.item.id, ...values }, (e) => Submit(values, propsFormik), (e) => {
            setMensagemModal(<>{e.response.data.alertas.map(x => <div className='mb-1'><b>{x}<br /></b></div>)}</>)
            setShowModalValidacao(true)
            setSalvando(false)
        })
    }

    const obterLote = () => {
        setCarregando(true)
        Promise.resolve(get(`/faturamento/loteGuia/${props.item.id}`)).then(val => {
            let valoresIn;
            if (val.id)
                valoresIn = {
                    lote: {
                        value: val.id,
                        label: val.numero_lote,
                        operadora_saude: val.operadora_saude ? val.operadora_saude.label : null,
                        quantidade_guia: val.quantidade_guia,
                        referencia: val.referencia ? moment(val.referencia, 'DD/MM/YYYY').format('MM/YYYY') : '',
                        status: val.status
                    }
                }
            else
                valoresIn = {}

            setValoresIniciais(valoresIn)
            setCarregando(false)
        })
    }

    useEffect(() => {
        setValoresIniciais({})
        if (props.item && props.item.id) {
            obterLote();
        }
    }, [props.item])

    const funcaoAposSim = (formik) => {
        setShowModalValidacao(false)
        Submit(formik.values, formik.resetForm)
    }

    return (
        <>
            <ModalCadastro titulo={props.titulo} show={props.abrirModal} setShowModal={props.setAbrirModal}>
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => validarSubmit(values, propsFormik)}>
                    {propsFormik => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className='modal-body-cadastro'>
                                    <div class="separator mt-20 mb-20"></div>
                                    <div className={'form-group col-12'}>
                                        {carregando === true ? <LoadRelatorio refLoading={refAtualizacao} heigth={320} /> : <>

                                            <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />
                                            <label className={'width-100 bold'}>Código Guia</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.id || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Código Barras</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.codigo_barras || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Nome</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.nome_beneficiario || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Operadora de Saúde</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.operadora_saude || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Empresa</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.empresa || '--' : '--'}</label>
                                            <InputLoteGuiaAcao label={<b>Lote</b>} name="lote" propsFormik={propsFormik} tamanho={'col-lg-12 p-0'}
                                                classeTooltip={'tooltip-input-modal'} placeholder="Lote" autoFocus obrigatorio guia={props.item} />
                                            <TextArea label={<b>Justificativa</b>} name='justificativa' type='text' placeholder='Justificativa' tamanho={!props.modal && 'col-lg-12 p-0'} rows={3}
                                                classeTooltip={props.modal && 'tooltip-input-modal'} />
                                            <label className={'width-100 bold'}>Status</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.status || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Operadora de Saúde</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.operadora_saude || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Qtde Guias por Lote</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.quantidade_guia || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Qtde Guias no Lote</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.qtd_guias || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Referência</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.referencia || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Descrição</label>
                                            <label className={'width-100 mb-20'}>{propsFormik.values.lote ? propsFormik.values.lote.descricao || '--' : '--'}</label>
                                        </>}
                                    </div>
                                </div>
                                <div className='separator mt-40 mb-2'></div>

                                <div className='direita container-botoes mb-3 group-salvar-novo'>
                                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => { }} idTooltip={"salvar"} />
                                </div>
                            </Form>
                            <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => funcaoAposSim(propsFormik)} funcaoOpcao1={() => { setSalvando(false); setShowModalValidacao(false) }}
                                esconderFechar mensagem={<>{<>{'Validações do Lote:'} <br /><br /></>} {mensagemModal}<br />
                                    {'Deseja Continuar?'}</>}
                                textoOpcao1={'Cancelar'}
                                classeOpcao1={'btn-sm btn-primary-modal simples'}
                                textoOpcao2={'Continuar'} />
                        </div>
                    )}
                </Formik>
            </ModalCadastro>
        </>
    );
}

const TrocarStatus = ({ target, ...props }) => {

    const [salvando, setSalvando] = useState(false)
    const [carregando, setCarregando] = useState(false)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [itemAtual, setItemAtual] = useState(null)

    const [validacao] = useState(Yup.object({
        status: Yup.object().nullable().required()
    }))

    useEffect(() => {
        const item = props.item
        setItemAtual(item);
        if (item.id_status) {
            setValoresIniciais({ status: { value: item.id_status, label: item.status } })
        }
        else
            setValoresIniciais({ status: null, justificativa: '' })

    }, [props.item])

    const Submit = (values, propsFormik) => {
        // if (values.status && parseInt(values.status.value) === 13)
        //     if (!values.data && values.hora)
        //         values.data_hora_guia_baixada = moment(values.hora, 'HH:mm').format('DD/MM/YYYY HH:mm')

        //     else if (values.data && !values.hora)
        //         values.data_hora_guia_baixada = moment(`${values.data} ${moment().format('HH:mm')}`, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')

        //     else
        //         values.data_hora_guia_baixada = moment().format('DD/MM/YYYY HH:mm')

        setSalvando(true)
        salvar(
            { id: props.item.id, ...values },
            '/faturamento/guiaalterarstatus',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                props.setAbrirModal(false)
                target.current.atualizar()
                setSalvando(false)
            },
            (err) => {
                setSalvando(false)
            })
    }

    const validarSubmit = async (values, propsFormik) => {
        const conferindo = GUIA_STATUS.CONFERIDA === values?.status?.value;
        let msgValidacao = [];
        setSalvando(true)

        if ((valoresIniciais.status && valoresIniciais.status.value === 13) && (values.status && values.status.value !== 13))
            msgValidacao.push(<><div className='mb-1'><b>Guia encontra-se com status "Baixada"<br /><br /></b></div></>)

        if (conferindo && !itemAtual.digitalizado)
            msgValidacao.push(<><div className='mb-1'><b>Guia não foi digitalizada<br /></b></div></>)

        if (msgValidacao.length > 0) {
            setMensagemModal(msgValidacao)
            setShowModalValidacao(true)
            setSalvando(false)
        } else
            Submit(values, propsFormik)
    }

    const funcaoAposSim = (formik) => {
        setShowModalValidacao(false)
        Submit(formik.values, formik.resetForm)
    }

    return (
        <>
            <ModalCadastro titulo={props.titulo} show={props.abrirModal} setShowModal={props.setAbrirModal}>
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => validarSubmit(values, propsFormik)}>
                    {propsFormik => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className='modal-body-cadastro'>
                                    <div class="separator mt-20 mb-20"></div>
                                    <div className={'form-group col-12'}>
                                        {carregando === true ? <LoadRelatorio refLoading={refAtualizacao} heigth={320} /> : <>

                                            <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />
                                            <InputGuiaStatus label={<b>Status</b>} name="status" propsFormik={propsFormik} tamanho={'col-lg-12 p-0'}
                                                classeTooltip={'tooltip-input-modal'} placeholder="Status" autoFocus obrigatorio status_guia_convenio />
                                            {/* {propsFormik.values.status && parseInt(propsFormik.values.status.value) === 13 && //Status Guia "baixada"
                                                <>
                                                    <InputDatePicker tamanho={!props.modal && 'col-lg-12 p-0'} label="Data" name="data" type="text"
                                                        classeTooltip={props.modal && 'tooltip-input-modal'} placeholder="Data"
                                                        setarValor={value => { propsFormik.setFieldValue("data", value) }} />
                                                    <InputTimePicker
                                                        label="Hora" mascara="11:11" name="hora" type="text" placeholder="Hora" tamanho={!props.modal && "col-lg-12 p-0"} classeTooltip={props.modal && 'tooltip-input-modal'}
                                                        setarValor={value => {
                                                            propsFormik.setFieldValue("hora", value)
                                                        }}
                                                    />
                                                </>} */}
                                            <TextArea label={<b>Justificativa</b>} name='justificativa' type='text' placeholder='Justificativa' tamanho={!props.modal && 'col-lg-12 p-0'} rows={3}
                                                classeTooltip={props.modal && 'tooltip-input-modal'} />
                                        </>}
                                    </div>
                                </div>
                                <div className='separator mt-40 mb-2'></div>

                                <div className='direita container-botoes mb-3 group-salvar-novo'>
                                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => { }} idTooltip={"salvar"} />
                                </div>
                            </Form>
                            <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => funcaoAposSim(propsFormik)} funcaoOpcao1={() => { setSalvando(false); setShowModalValidacao(false) }}
                                esconderFechar mensagem={<>{<>{'Validações do Status:'} <br /><br /></>} {mensagemModal}<br />
                                    {'Deseja Continuar?'}</>}
                                textoOpcao1={'Cancelar'}
                                classeOpcao1={'btn-sm btn-primary-modal simples'}
                                textoOpcao2={'Continuar'} />
                        </div>
                    )}
                </Formik>
            </ModalCadastro>
        </>
    );
}

const ModalArquivos = ({ target, ...props }) => {
    const [salvando, setSalvando] = useState(false)
    const [carregando, setCarregando] = useState(false)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [dataArquivos, setDataArquivos] = useState(null)
    const [limparArquivos, setLimparArquivos] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const refArquivo = useRef(null)

    const [validacao] = useState(Yup.object({}))

    const Submit = (values, propsFormik) => {
        values.arquivo = dataArquivos
        setSalvando(true)
        let valuesAjustados = { ...values }
        valuesAjustados.status = values.status ? values.status.id : ''
        putComAcao(
            ACOES.INSERIR_ARQUIVOS_GUIA,
            76,
            { id: props.item.id, ...values },
            '/faturamento/guiaInserirArquivos',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                props.setAbrirModal(false)
                setSalvando(false)
                props.setItem(null)
                setDataArquivos(null)
                // target.current.atualizar()
            },
            (erro) => {
                console.log('ERRO ', erro)
                setSalvando(false)
                mostrarToast('erro', mensagens.erro);
            })
    }

    useEffect(() => {
        if (props.item && props.item.id) {
            obterArquivo()
        }
    }, [props.item])

    const obterArquivo = async () => {

        setCarregando(true)
        await Promise.resolve(get(`/faturamento/guiaArquivos/${props.item.id}`)).then(val => {
            setDataArquivos([...val] || [])
            setCarregando(false)
        })

    }
    useEffect(_ => {
        if (!props.abrirModal && refArquivo.current)
            refArquivo.current.limparArquivos()

    }, [props.abrirModal])

    useEffect(_ => {
        setSubmitting(dataArquivos?.filter(x => x.s3Key === undefined).length > 0)
    }, [dataArquivos, submitting])

    return (
        <>
            <ModalCadastro titulo={props.titulo} show={props.abrirModal} setShowModal={props.setAbrirModal}>
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
                    {_ => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className='modal-body-cadastro'>
                                    <div class="separator mt-20 mb-20"></div>
                                    <div className={'form-group col-12'}>
                                        {carregando === true ? <LoadRelatorio refLoading={refAtualizacao} heigth={320} /> : <>

                                            <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />
                                            <label className={'width-100 bold'}>Código Guia</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.id || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Código Barras</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.codigo_barras || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Nome</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.nome_beneficiario || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Data Procedimento</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.data_procedimento || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Operadora de Saúde</label>
                                            <label className={'width-100 mb-20'}>{props.item ? props.item.operadora_saude || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Status</label>
                                            <label className={'width-70 mb-20 tag'} style={{ backgroundColor: props.item.cor_status, color: 'white' }}>{props.item ? props.item.status || '--' : '--'}</label>
                                            <label className={'width-100 bold'}>Lote</label>
                                            <label className={'width-100 mb-20 '}>{props.item ? props.item.numero_lote || '--' : '--'}</label>
                                            <div className="">
                                                {dataArquivos != null ?
                                                    <InputArquivoS3
                                                        ref={refArquivo}
                                                        name='arquivo'
                                                        placeholder='Arquivo'
                                                        tamanho='col-12'
                                                        diretorioS3='guia/DDMMYYYY/'
                                                        modulo={MODULO["/faturamento/guia"]}
                                                        tamanhoMinimo={0}
                                                        tamanhoMaximoEmMB={300}
                                                        setDataArquivos={setDataArquivos}
                                                        dataArquivos={dataArquivos != null ? dataArquivos : []}
                                                        modal={true}
                                                        setIsSubmit={dataArquivos.length > 0 ? setSalvando : () => { }}
                                                        limparCampos={false}
                                                    /> : <></>}
                                            </div>
                                        </>}
                                    </div>
                                </div>
                                <div className='separator mt-40 mb-2'></div>

                                <div className='direita container-botoes mb-3 group-salvar-novo'>
                                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => { }} idTooltip={"salvar"} />
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </ModalCadastro>
        </>
    );
}
export default ConsultaGuia